export const ROLE_TYPE = {
  SUPERADMIN: 'superadmin',
  PARTSSUPERADMIN: 'partsSuperAdmin',
  ADMIN: 'admin',
  USER: 'user'
}

export const SYSTEM_SETTING_TYPE = {
  RUN_STATUS:'RUN_STATUS',
  ASSET_NAME:'ASSET_NAME',
  ASSET_ID:'ASSET_ID',
  ASSET_LAYER_NAME:'ASSET_LAYER_NAME',
  OEE_TEMPLATE_CONFIG:'OEE_TEMPLATE_CONFIG',
  LOSS_TEMPLATE_CONFIG:'LOSS_TEMPLATE_CONFIG'
}

export const APP_NAME = 'Area'
export const APP_VERSION = 'v1.1.4'